// Websocket feed

export const WS_FEED_CONNECTION_START: "WS_FEED_CONNECTION_START" = "WS_FEED_CONNECTION_START";
export const WS_FEED_CONNECTION_SUCCESS: "WS_FEED_CONNECTION_SUCCESS" =
  "WS_FEED_CONNECTION_SUCCESS";
export const WS_FEED_CONNECTION_ERROR: "WS_FEED_CONNECTION_ERROR" = "WS_FEED_CONNECTION_ERROR";
export const WS_FEED_CONNECTION_CLOSED: "WS_FEED_CONNECTION_CLOSED" =
  "WS_FEED_CONNECTION_CLOSED";
export const WS_FEED_GET_MESSAGE: "WS_FEED_GET_MESSAGE" = "WS_FEED_GET_MESSAGE";
export const WS_FEED_SEND_MESSAGE: "WS_FEED_SEND_MESSAGE" = "WS_FEED_SEND_MESSAGE";
export const WS_FEED_CLOSE_CONNECTON: "WS_FEED_CLOSE_CONNECTON" = "WS_FEED_CLOSE_CONNECTON";

// Websocket orders history

export const WS_PROFILE_ORDERS_CONNECTION_START: "WS_PROFILE_ORDERS_CONNECTION_START" = "WS_PROFILE_ORDERS_CONNECTION_START";
export const WS_PROFILE_ORDERS_CONNECTION_SUCCESS: "WS_PROFILE_ORDERS_CONNECTION_SUCCESS" =
  "WS_PROFILE_ORDERS_CONNECTION_SUCCESS";
export const WS_PROFILE_ORDERS_CONNECTION_ERROR: "WS_PROFILE_ORDERS_CONNECTION_ERROR" = "WS_PROFILE_ORDERS_CONNECTION_ERROR";
export const WS_PROFILE_ORDERS_CONNECTION_CLOSED: "WS_PROFILE_ORDERS_CONNECTION_CLOSED" =
  "WS_PROFILE_ORDERS_CONNECTION_CLOSED";
export const WS_PROFILE_ORDERS_GET_MESSAGE: "WS_PROFILE_ORDERS_GET_MESSAGE" = "WS_PROFILE_ORDERS_GET_MESSAGE";
export const WS_PROFILE_ORDERS_SEND_MESSAGE: "WS_PROFILE_ORDERS_SEND_MESSAGE" = "WS_PROFILE_ORDERS_SEND_MESSAGE";
export const WS_PROFILE_ORDERS_CLOSE_CONNECTON: "WS_PROFILE_ORDERS_CLOSE_CONNECTON" = "WS_PROFILE_ORDERS_CLOSE_CONNECTON";
